import React from 'react';
import { motion } from 'framer-motion';
import { Check, Lock } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Offer() {
  const items = [{
    name: 'Guía principal: Recetas Caseras Saludables para Perros',
    value: 19
  }, {
    name: 'Bono 1: Póster Semáforo Canino de Ingredientes',
    value: 9
  }, {
    name: 'Bono 2: Planificador Canino de 7 Días',
    value: 12
  }, {
    name: 'Bono 3: Diario de Tolerancia Digestiva Canina',
    value: 9
  }, {
    name: 'Bono 4: Tarjetas de Sustitución Canina Express',
    value: 9
  }, {
    name: 'Bono 5: Kit SOS Alimentario Canino',
    value: 12
  }];
  return <section id="oferta" className="py-20 px-4 bg-brand-navy text-white" data-id="element-128">
      <div className="max-w-3xl mx-auto" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white text-brand-navy rounded-[2.5rem] p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-130">
          {/* Decorative top bar */}
          <div className="absolute top-0 left-0 w-full h-3 bg-brand-orange" data-id="element-131"></div>

          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-10" data-id="element-132">
            Todo lo que recibirás hoy:
          </h2>

          <div className="space-y-4 mb-10" data-id="element-133">
            {items.map((item, index) => <div key={index} className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0" data-id="element-134">
                <div className="flex items-center gap-3" data-id="element-135">
                  <div className="bg-green-100 p-1 rounded-full shrink-0" data-id="element-136">
                    <Check className="w-4 h-4 text-green-600" data-id="element-137" />
                  </div>
                  <span className="font-medium text-gray-700" data-id="element-138">{item.name}</span>
                </div>
                <span className="text-gray-400 font-medium whitespace-nowrap ml-4" data-id="element-139">
                  Valor ${item.value}
                </span>
              </div>)}
          </div>

          <div className="bg-brand-cream rounded-2xl p-6 mb-8 text-center border border-brand-beige" data-id="element-140">
            <p className="text-gray-500 text-lg mb-2 line-through" data-id="element-141">
              Valor total: $70 USD
            </p>
            <p className="text-4xl md:text-5xl font-extrabold text-brand-orange mb-2" data-id="element-142">
              Precio de lanzamiento: $6.36 USD
            </p>
            <p className="text-red-500 font-bold text-sm uppercase tracking-wide mt-4 animate-pulse" data-id="element-143">
              Este precio de lanzamiento es por tiempo limitado. Una vez que
              termine el lanzamiento, el precio subirá.
            </p>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-144">
            <CTAButton className="w-full md:w-auto md:px-12 md:py-5 text-xl" data-id="element-145">
              Quiero el pack completo por $6.36
            </CTAButton>
            <p className="flex items-center gap-2 text-sm text-gray-500 mt-2" data-id="element-146">
              <Lock className="w-4 h-4" data-id="element-147" />
              Compra segura. Acceso digital inmediato. Recibirás tus archivos
              PDF después del pago.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}